import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import uk from './locales/uk.json';
import pl from './locales/pl.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

// Detect language from URL path prefix — /uk/* → 'uk', /pl/* → 'pl', /de/* → 'de', /fr/* → 'fr', else 'en'.
// Path prefix is the canonical source of truth; English has no prefix.
function detectLangFromPath(): string {
  const m = window.location.pathname.match(/^\/(uk|pl|de|fr)(\/|$)/);
  return m ? m[1]! : 'en';
}

i18n
  .use(initReactI18next)
  .init({
    lng: detectLangFromPath(),
    resources: {
      en: { translation: en },
      uk: { translation: uk },
      pl: { translation: pl },
      de: { translation: de },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'uk', 'pl', 'de', 'fr'],
    interpolation: {
      escapeValue: false,
    },
  });

// Keep <html lang="..."> and localStorage in sync with the active language
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  localStorage.setItem('tth_lang', lng);
});

export default i18n;
